"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TimeInput = void 0;
var _react = require("react");
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["onChange", "onBlur", "value"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var timeValidator = function timeValidator(_ref) {
  var formattedValue = _ref.formattedValue;
  var _formattedValue$split = formattedValue.split(':').map(function (n) {
      return parseInt(n, 10) || 0;
    }).slice(-2),
    _formattedValue$split2 = _slicedToArray(_formattedValue$split, 2),
    minutes = _formattedValue$split2[0],
    seconds = _formattedValue$split2[1];
  return ![minutes, seconds].some(function (value) {
    return value >= 60;
  });
};
function useFormatterWithZero(_ref2) {
  var format = _ref2.format,
    _ref2$mask = _ref2.mask,
    mask = _ref2$mask === void 0 ? '' : _ref2$mask;
  var isMasked = function isMasked(ch) {
    if (typeof mask === 'string') {
      return mask === ch;
    }
    return mask.some(function (maskCh) {
      return maskCh === ch;
    });
  };
  return function (formattedValue) {
    if (!formattedValue) {
      return '';
    }
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
      if (format[i] === '#') {
        var ch = formattedValue[i];
        if (isMasked(ch) || !/[1-9]/.test(ch)) {
          formattedNumberAry[i] = '0';
        } else {
          formattedNumberAry[i] = ch;
        }
      }
    }
    return formattedNumberAry.join('');
  };
}
var TimeInput = exports.TimeInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
  var onChange = _ref3.onChange,
    _onBlur = _ref3.onBlur,
    value = _ref3.value,
    props = _objectWithoutProperties(_ref3, _excluded);
  var formatWithZero = useFormatterWithZero(props);
  var _useState = (0, _react.useState)(value),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  (0, _react.useEffect)(function () {
    if (value !== inputValue) {
      setInputValue(value);
    }
  }, [value]);
  var handleChange = function handleChange(values) {
    setInputValue(values.formattedValue);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactNumberFormat["default"], _objectSpread(_objectSpread({
    value: inputValue,
    customInput: _TextField["default"],
    onValueChange: handleChange,
    isAllowed: timeValidator,
    getInputRef: ref,
    debounceTimeout: 0
  }, props), {}, {
    onBlur: function onBlur(e) {
      var formattedValue = formatWithZero(inputValue);
      if (formattedValue !== value) {
        onChange({
          target: formattedValue
        }, formattedValue);
      } else if (formattedValue !== inputValue) {
        setInputValue(formattedValue);
      }
      if (_onBlur) {
        _onBlur(e);
      }
    }
  }));
});
var _default = exports["default"] = TimeInput;